module.exports = __webpack_public_path__ + "static/media/SIDE VENTS.0b6253d2.svg";